import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inventario/listadoPrecios';
import Listado from './ListadoPreciosList';


const ms2p = (state) => {
  return {
    ...state.listado_precios_inv,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Listado);
